/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


    $('.sliderule__wrapper .sliderow').click(function() {
      var current_status = $(this).parent().find(".custom-mobile-submenu-block").css('display');
      $('.sliderow').removeClass('active');
      $('.sliderule__wrapper .custom-mobile-submenu-block').slideUp();
      //$(this).addClass('active');
      if(current_status == 'none') {
        $(this).addClass('active');
        //$(this).next().addClass('active');
        $(this).parent().find(".custom-mobile-submenu-block").slideDown();
      }
    });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
